import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Button, Col, Form, Row } from "react-bootstrap";
import * as message from "../../config/CommonMessages";
import { Link } from "react-router-dom";
import { Close } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import * as code from "./../../config/Constants";
import $ from "jquery";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { toastMessage } from "./../Common/Common";
import DatePicker from "react-datepicker";
import { DateRange } from "@material-ui/icons";
import moment from "moment";

import {
  getSystemBannerDetailsAction,
  addSystemBannersAction,
  editSystemBannersAction,
} from "../../actions/SystemBannersActions";

function SystemBannerForm({
  getSystemBannerDetailsAction,
  addSystemBannersAction,
  editSystemBannersAction,
}) {
  const minsDate = moment().format("YYYY-MM-DD");
  const initialState = {
    title: "",
    textEditorVal: EditorState.createEmpty(),
    startDate: new Date(),
    endDate: new Date(),
    isActive: false,
  };

  const history = useHistory();
  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [disable, setDisable] = useState(false);
  const [msgEditor, setMsgEditor] = useState("");
  const [editFlag, setEditFlag] = useState(false);

  useEffect(() => {
    if (history.location.state !== undefined) {
      setEditFlag(true);
      getBannerDetails(history.location.state.id);
    }
  }, []);

  function getBannerDetails(id) {
    getSystemBannerDetailsAction(id).then((response) => {
      let result = response.data;
      if (response.status === 200) {
        setMsgEditor(result.message);

        var textEditorVal = EditorState.createEmpty();
        let contentBlock = htmlToDraft(result.message);
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock.contentBlocks
          );
          textEditorVal = EditorState.createWithContent(contentState);
        }

        let details = {
          title: result.title,
          textEditorVal: textEditorVal,
          startDate: new Date(result.startDate),
          endDate: new Date(result.endDate),
          isActive: result.Isactive,
        };

        setForm(details);
      }
    });
  }

  const findFormErrors = () => {
    const { title, startDate, endDate, isActive } = form;
    const newErrors = {};
    // title errors
    if (!title || title.trim() === "") {
      newErrors.title = message.ENTER_SYSBANNER_TITLE;
    }

    //message per error
    if (
      !msgEditor ||
      msgEditor.trim() === "" ||
      msgEditor.trim() === "<p></p>"
    ) {
      newErrors.template = message.ENTER_SYSBANNER_MESSAGE;
    }

    //date errors
    var mStart = moment(startDate);
    var mEnd = moment(endDate);
    if (!mStart.isSameOrBefore(mEnd)) {
      newErrors.endDate = message.BANNER_END_DATE_INVALID;
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // get our new errors
    const newErrors = findFormErrors();
    // Conditional logic:
    if (Object.keys(newErrors).length > 0) {
      // We got errors!
      setErrors(newErrors);
    } else {
      // No errors! Put any logic here for the form submission!
      setDisable(true);
      let formattedstartDate = moment(form.startDate).format("YYYY-MM-DD");
      let formattedEndDate = moment(form.endDate).format("YYYY-MM-DD");

      let data = {
        title: form.title.trim(),
        message: msgEditor,
        startDate: formattedstartDate,
        endDate: formattedEndDate,
        Isactive: form.isActive,
      };
      if (editFlag) {
        editSystemBanner(data);
      } else {
        addSystemBanner(data);
      }
    }
  };

  function addSystemBanner(values) {
    addSystemBannersAction(values)
      .then((res) => {
        if (res.status === code.OK) {
          setDisable(false);
          history.push({
            pathname: "/systemBanners",
          });
        } else {
          //   if (res.data === "duplicate") {
          //     setBillinPlanduplicat(true);
          //   }
          setDisable(false);
          toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        }
      })
      .catch((err) => {});
  }

  function editSystemBanner(values) {
    editSystemBannersAction(values, history.location.state.id)
      .then((res) => {
        if (res.status === code.OK) {
          setDisable(false);
          history.push({
            pathname: "/systemBanners",
          });
        } else {
          //   if (res.data === "duplicate") {
          //     setBillinPlanduplicat(true);
          //   }
          setDisable(false);
          toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        }
      })
      .catch((err) => {});
  }

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
    // Check and see if errors exist, and remove them from the error object:
    if (!!errors[field]) {
      setErrors({
        ...errors,
        [field]: null,
      });
    }
  };
  return (
    <>
      <div className="step-progress transaction-create">
        <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
          <Col xs={12} sm={3}>
            <h4 className="title-med mt-0 pt-1">
              {editFlag ? "Edit System Banner" : "Add System Banner"}
            </h4>
          </Col>

          <Col xs={12} sm={6} />

          <Col xs={12} sm={3} align="right" className="transaction-close">
            <Link to="/systemBanners" className="nav-link p-0 color-black">
              <Close
                style={{ stroke: "#fff", height: "40px", width: "40px" }}
              />
            </Link>
          </Col>
        </Row>
        <div className="multi-step multi-step-admin">
          <div className="admin-steps admin-content-area">
            <div className="container-custom">
              <Form className="form-sm form-admin" onSubmit={handleSubmit}>
                <Row>
                  <Col md={12}>
                    <h3 className="title-small font-600 mt-2 mb-3 pt-3">
                      System Banner Details
                    </h3>

                    <Row>
                      <Col xs={12} sm={6}>
                        <Form.Group>
                          <Form.Label>
                            Title <span className="text-danger"> *</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="title"
                            value={form.title}
                            onChange={(e) => setField("title", e.target.value)}
                            isInvalid={!!errors.title}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.title}
                          </Form.Control.Feedback>
                          {/* {billinPlanduplicat ? (
                            <div
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              Billing plan name is duplicate
                            </div>
                          ) : (
                            ""
                          )} */}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={6}>
                        <Form.Group>
                          <Form.Label>
                            Message <span className="text-danger"> *</span>
                          </Form.Label>
                          <Editor
                            wrapperClassName="demo-wrapper wysi-editor"
                            editorClassName="demo-editor"
                            toolbar={{
                              options: ["inline", "list", "link", "blockType"],
                              inline: {
                                inDropdown: false,
                                options: ["bold", "italic"],
                              },
                              list: {
                                inDropdown: true,
                                options: ["unordered", "ordered"],
                              },
                              link: { inDropdown: false, options: ["link"] },
                              blockType: {
                                inDropdown: false,
                                options: ["Blockquote"],
                              },
                            }}
                            name="template"
                            editorState={form.textEditorVal}
                            onEditorStateChange={(e) => {
                              var ediData = draftToHtml(
                                convertToRaw(e.getCurrentContent())
                              );
                              //get editor data and enclose it with output
                              var tempDom = $("<output>").append(
                                $.parseHTML(ediData)
                              );
                              //remove link with mension data
                              $.map(
                                tempDom.find("a.wysiwyg-mention"),
                                function (elem, index) {
                                  let newVal = $(elem).html();
                                  elem.replaceWith(newVal);
                                }
                              );

                              let finalval = tempDom.html();

                              // setFieldValue("template", $(finalval).text());
                              setField("textEditorVal", e);
                              setMsgEditor(finalval);
                            }}
                            hashtag={{}}
                          />
                          {!!errors.template ? (
                            <div
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              {errors.template}
                            </div>
                          ) : (
                            ""
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} sm={2}>
                        <Form.Label>Start Date</Form.Label>
                        <Form.Group>
                          <DatePicker
                            onChange={(date) => {
                              setField("startDate", date);
                            }}
                            name="startDate"
                            className="form-control form-control-sm pl-1 date-picker"
                            dateFormat="MM-d-yyyy"
                            selected={form.startDate}
                            minDate={new Date(minsDate)}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={2}>
                        <Form.Label>End Date</Form.Label>
                        <Form.Group>
                          <DatePicker
                            onChange={(date) => {
                              setField("endDate", date);
                            }}
                            name="endDate"
                            className="form-control form-control-sm pl-1 date-picker"
                            dateFormat="MM-d-yyyy"
                            selected={form.endDate}
                            minDate={new Date(minsDate)}
                          />
                          {!!errors.endDate ? (
                            <div
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              {errors.endDate}
                            </div>
                          ) : (
                            ""
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} sm={2}>
                        <Form.Group style={{ display: "block" }}>
                          <Form.Check
                            name="isActive"
                            checked={form.isActive}
                            onChange={(e) => {
                              setField("isActive", e.target.checked);
                            }}
                            style={{ display: "inline" }}
                          />
                          <Form.Label
                            style={{ display: "inline", paddingLeft: 10 }}
                          >
                            Status
                          </Form.Label>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} sm={3} />
                    </Row>
                  </Col>
                </Row>
                <Row className="form-group pt-4 pb-4">
                  <Col>
                    <Button
                      type="submit"
                      variant="primary"
                      className="btn-blue w-90 font-14 mr-3"
                      disabled={disable}
                    >
                      Save
                    </Button>
                    <Button
                      variant="primary"
                      className="btn-blue btn-outlined w-90 font-14"
                      onClick={() => history.push("/systemBanners")}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  getSystemBannerDetailsAction,
  addSystemBannersAction,
  editSystemBannersAction,
})(SystemBannerForm);
